import { Outlet } from "react-router-dom";

//elements
import Footer from "../elements/footer/Footer"
import NavBar from "../elements/navbar/Navbar"

//graphics
// import logo from '../img/graphics/NAS Logo Color smaller.png'


export default function RootLayout() {
  return (
    <div className="rootLayout">
        <header>         
            <NavBar />        
         </header>
         <main>
            <Outlet />
         <Footer />
         </main>
         
        </div>
  )
}
